import { useEffect, useState } from 'react';
import axios from 'axios';
import { Table, Button, Form } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import UserForm from '../components/UserForm';

const API_URL = process.env.REACT_APP_API_URL;

interface User {
  id: number;
  username: string;
  email: string;
  role: string;
  roles: string[];
}

function UserTable() {
  const [users, setUsers] = useState<User[]>([]);
  const [editingId, setEditingId] = useState<number | null>(null);
  //const [editedUser, setEditedUser] = useState<Partial<User>>({});
  const [editedUser, setEditedUser] = useState<Partial<User>>({});
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    axios.get<User[]>(`${API_URL}/auth/users`).then(res => setUsers(res.data));
  }, []);

  const handleEdit = (user: User) => {
    setEditingId(user.id);
    setEditedUser({ ...user });
  };

  const handleAddUser = (newUser: User) => {
    setUsers([...users, newUser]);
  };

  const handleSave = async () => {
    if (!editingId) return;
    await axios.put(`${API_URL}/auth/users/${editingId}`, editedUser);
    const updated = users.map(u => (u.id === editingId ? { ...u, ...editedUser } : u));
    setUsers(updated);
    setEditingId(null);
  };

  return (    
    <Table striped bordered hover>
      <thead>
        <div className="d-flex justify-content-between align-items-center mb-3">
            <h3>Usuarios</h3>
            <Button variant="success" onClick={() => setShowModal(true)}>Agregar Usuario</Button>
        </div>        
        <tr>
          <th>Usuario</th>
          <th>Email</th>
          <th>Rol</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        {users.map(user => (
          <tr key={user.id}>
            <td>
              {editingId === user.id ? (
                <Form.Control
                  value={editedUser.username || ''}
                  onChange={e => setEditedUser({ ...editedUser, username: e.target.value })}
                />
              ) : (
                user.username
              )}
            </td>
            <td>
              {editingId === user.id ? (
                <Form.Control
                  value={editedUser.email || ''}
                  onChange={e => setEditedUser({ ...editedUser, email: e.target.value })}
                />
              ) : (
                user.email
              )}
            </td>
          <td>
            {editingId === user.id ? (
              <Form.Select
                multiple
                value={editedUser.roles || []}
                onChange={(e) => {
                  const selected = Array.from(e.target.selectedOptions, opt => opt.value);
                  setEditedUser({ ...editedUser, roles: selected });
                }}
              >
                <option value="admin">Admin</option>
                <option value="editor">Editor</option>
                <option value="viewer">Viewer</option>
                <option value="clusters">Clusters</option>
                <option value="search">Encuestador</option>
              </Form.Select>
            ) : (
              user.roles.join(", ")
            )}
          </td>            
          <td>
            {editingId === user.id ? (
                <>
                <Button variant="success" size="sm" onClick={handleSave}>Guardar</Button>{' '}
                <Button
                variant="secondary"
                size="sm"
                onClick={() => {
                    setEditingId(null);
                    setEditedUser({});
                }}
                >
                Cancelar
                </Button>
                </>
            ) : (
                <Button variant="primary" size="sm" onClick={() => handleEdit(user)}>Editar</Button>
            )}
            </td>
          </tr>
        ))}
      </tbody>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Crear Usuario</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <UserForm onSuccess={handleAddUser} onClose={() => setShowModal(false)} />
        </Modal.Body>
      </Modal>
    </Table>    
  );
}

export default UserTable;